var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, FormControl, FormHelperText, IconButton, InputLabel, Link, MenuItem, Select, } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import { paths } from "frontend/src/pages/paths";
import { usePrograms } from "frontend/src/domain/programs";
var useStyles = makeStyles({
    formControl: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        width: "100%",
    },
    edit: {
        opacity: function (_a) {
            var isHovered = _a.isHovered;
            return (isHovered ? 1 : 0);
        },
    },
});
export var ProgramRulesetSelect = function (_a) {
    var _b;
    var value = _a.value, onChange = _a.onChange, programNotSelectedError = _a.programNotSelectedError;
    var programs = usePrograms();
    var _c = __read(React.useState(false), 2), isHovered = _c[0], setHovered = _c[1];
    var classes = useStyles({ isHovered: isHovered });
    var onProgramChange = function (evt) {
        var value = evt.target.value;
        if (typeof value === "string") {
            var id = parseInt(value);
            if (!isNaN(id)) {
                onChange(id);
            }
        }
        else if (typeof value === "number") {
            onChange(value);
        }
    };
    if (!programs.data) {
        return React.createElement(Skeleton, null);
    }
    return (React.createElement(Box, { onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); } },
        React.createElement(FormControl, { className: classes.formControl },
            React.createElement(InputLabel, null, "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430"),
            React.createElement(Select, { fullWidth: true, onChange: onProgramChange, value: value === -1 ? "" : value, error: programNotSelectedError }, (_b = programs.data) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                var id = _a.id, title = _a.title;
                return (React.createElement(MenuItem, { key: id, value: id }, title));
            })),
            value !== -1 && (React.createElement(Box, { ml: 1, className: classes.edit },
                React.createElement(Link, { component: RouterLink, to: paths.business.owner.programs.edit(value) },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(Edit, null)))))),
        programNotSelectedError && (React.createElement(FormHelperText, { error: true }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443."))));
};
